import { useHistory } from 'react-router-dom';

interface UseNavigateToTab {
  navigateToImportErrorsTab: () => void;
}

const useNavigateToTab = (): UseNavigateToTab => {
  const history = useHistory();

  const navigateToImportErrorsTab = () => {
    const newSearchParams = new URLSearchParams(history.location.search);
    newSearchParams.set('commandCenter', 'data');
    newSearchParams.set('data-tab', 'import-errors');

    history.push({ ...history.location, search: newSearchParams.toString() });
  };

  return { navigateToImportErrorsTab };
};

export default useNavigateToTab;
